import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Progress } from "@/components/ui/progress";

interface InventoryHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  progress: number;
  handleFinishInventory: () => void;
  setIsActive: (active: boolean) => void;
  inventoryData: any[];
}

export const InventoryHeader = ({
  searchQuery,
  setSearchQuery,
  progress,
  handleFinishInventory,
  setIsActive,
  inventoryData,
}: InventoryHeaderProps) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-semibold">Mode Inventaire</h2>
        <div className="space-x-2">
          <Button
            variant="outline"
            onClick={() => setIsActive(false)}
          >
            Annuler
          </Button>
          <Button
            onClick={handleFinishInventory}
            disabled={inventoryData.length === 0}
          >
            Terminer l'inventaire
          </Button>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <Input
          placeholder="Rechercher un produit..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="max-w-sm"
        />
        <div className="flex items-center gap-4">
          <span className="text-sm text-gray-500">
            Progression: {Math.round(progress)}%
          </span>
          <Progress value={progress} className="w-[200px]" />
        </div>
      </div>
    </div>
  );
};